var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-box" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("section", { staticClass: "spaceCenter login-main" }, [
        _c("div", { staticClass: "login-text" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "login-form spaceCenter" },
          [
            _c(
              "transition",
              { attrs: { name: "fade2", mode: "out-in" } },
              [_c("router-view")],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("footer", [
        _c("div", { staticClass: "footer-text" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("a", { staticClass: "app-a", on: { click: _vm.showModal } }, [
            _vm._v("《告知书》")
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            bodyStyle: { height: "500px", overflow: "auto" },
            width: "600px",
            title: "告知书",
            visible: _vm.modalShow
          },
          on: { cancel: _vm.modalCancel }
        },
        [
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticClass: "spaceCenter" },
              [
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return (function() {
                          _vm.modalShow = false
                        })($event)
                      }
                    }
                  },
                  [_vm._v("关闭")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("notification")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "login-logo spaceBetween" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/nylogo.png"),
          alt: "",
          srcset: "",
          height: "40"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c(
        "a",
        {
          staticStyle: { color: "#666" },
          attrs: { href: "https://beian.miit.gov.cn", target: "_blank" }
        },
        [
          _vm._v("Copyright@2023 南阳商祺数贸科技有限公司 电话:400-0377-900\n"),
          _c("br"),
          _vm._v("版权所有豫ICP备2023000680号-2 豫ICP证B2-20231049号")
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b783b1ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b783b1ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components-frame/login.vue
// module id = QDm7
// module chunks = 1